<template>
	<div class="long_row learner_explore_programs">

		<div class="row">
			<div class="col-12">
				<div class="sec_tp_msg ace_sec">
					<span>{{exploreProgramText}} {{exploreProgramsLabelPlural}}</span>
				</div>
			</div>
		</div>

    <div class="row pkg_entity_bx_container" :class="setEntityContainerWidthClass(explorePrograms.length)">
      <div v-for="(pg, i) in explorePrograms" class="col-3 explore_intro">
				<div class="pkg_entity_bx programs">
          <button @click.stop="goToProgramGuideDetail(pg)" class="ace_sec" :aria-label="'program ' + pg.title">
            <span class="bx_inner">
              <span :class="{'thumbnail_container': !pg.thumbnailURL, 'program-thumbnail': pg.thumbnailURL}">
                <div class="thumbnail_img" v-if="pg.thumbnailURL" :class="setImageBgColor(pg.thumbnailURL)">
                  <img v-bind:src="pg.thumbnailURL" alt="Img">
                </div>
                <div v-else class="ico-degreeProgram ic"></div>
              </span>
              <span class="entity_title" :id="'programGuideTitle_' + i">
                <v-clamp class="entity_title_txt" autoresize :max-lines="2">{{ pg.title }}</v-clamp>
              </span>

							<b-popover :target="'programGuideTitle_' + i" triggers="hover" placement="top" class="title_popup" :container="'entityNameContainer_' + i">
								<div class="title_container">
									{{ pg.title }}
								</div>
							</b-popover>
							<div :id="'entityNameContainer_' + i" class="title_container_popup"></div>

            </span>
          </button>
        </div>
      </div>
			<div class="col-3 explore_intro explore_more" v-if="explorePrograms.length > 2">
        <div class="pkg_entity_bx programs">
          <button @click="exploreProgramsClicked" class="ace_sec">
            <span class="bx_inner">
              <span class="thumbnail_container">
                <div class="ico-degreeProgram ic"></div>
              </span>
              <span class="entity_title pg-title btn_txt_lc">
                <span class="entity_title_txt">Explore<br />{{programShortNameLabelPlural}}</span>
              </span>
            </span>
          </button>
        </div>
      </div>
    </div>

    <div class="row mt-2 sec_msg">
      <div class="col-12 ace_sec sec_btm_msg">
        <span>You can also <a href="javascript://" @click="exploreCareersClicked">explore careers.</a></span>
      </div>
    </div>
	</div>
</template>

<script>
	import { mapActions, mapState } from 'vuex'
	import { StorageFactory } from '../../../storageFactory'
	import VClamp from 'vue-clamp'
  import { PACKAGE } from '../../../package_constants'
  import { PackageUtil } from '../../../package_utils'

  export const localStore = StorageFactory(() => localStorage)

	export default {
		name: 'learner-explore-programs',
		components: {
      VClamp
    },
		data: () => {
			return {
        explorePrograms: [],
				exploreProgramText: 'Check out our '
			}
		},
    created () {
      this.populateLearnerDashboradPrograms()
    },
    beforeMount () {
      this.$root.$on('reloadLearnerDashboard', () => {
        this.populateLearnerDashboradPrograms()
      })
    },
    computed: {
      ...mapState({
        'enabledFeatures': state => state.institution.enabledFeatures,
        'packages': state => state.institution.packages,
      }),
      exploreProgramsFlagMap () {
        let featureId = PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS
        let exploreSearchPackage = this.getExploreSearchPackage()
        return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
      },
      exploreProgramsLabelPlural () {
        let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS]
        if (exploreFeature) {
          for (var i = 0; i < exploreFeature.flags.length; i++) {
            if (exploreFeature.flags[i].title === 'useProgramLongText') {
              if (exploreFeature.flags[i].isEnabled) {
                return exploreFeature.flags[i].label + 's'
              }
            }
          }
				}
				return 'programs'
      },
      programShortNameLabelPlural () {
        let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS]
        if (exploreFeature) {
          for (var i = 0; i < exploreFeature.flags.length; i++) {
            if (exploreFeature.flags[i].title === 'useProgramShortText') {
              if (exploreFeature.flags[i].isEnabled) {
                return exploreFeature.flags[i].label + 's'
              }
            }
          }
        }
				return 'programs'
      },
    },
		methods: {
			...mapActions([
	      'loadLearnerExplorePrograms'
	    ]),
      getExploreSearchPackage () {
        let packages = this.packages
        if (!packages || !packages.length || packages.length <= 0) {
          return {}
        }
				return PackageUtil.getExploreSearchPackage(packages)
      },
      populateLearnerDashboradPrograms () {
        this.loadLearnerExplorePrograms().then(resp => {
          this.explorePrograms = resp
        })
			},
      exploreProgramsClicked () {
        return this.$router.push({name: 'exploreProgramGuideResults'})
      },
      exploreCareersClicked () {
        return this.$router.push({name: 'exploreCareerResults'})
      },
      setImageBgColor (imageURL) {
				let getImageURL = imageURL.split('/')
        let getImageName = getImageURL[getImageURL.length - 1].match(/(.*)\.[\w]+$/)[1]
        return getImageName.replace(/\./g, '__')
      },
			setEntityContainerWidthClass (exploreProgramsLength) {
				if (exploreProgramsLength > 2 ) {
				 $('.profile_builder').removeClass('short_row')
				 $('.learner_explore_programs').removeClass('short_row')
			  } else {
				 $('.profile_builder').addClass('short_row')
				 $('.learner_explore_programs').addClass('short_row')
			  }
			},
      goToProgramGuideDetail (programGuide) {
        let routerParams = {
          cipCode: programGuide.cipCode,
          programGuideCode: programGuide.code,
          type: programGuide.type,
          returnTo: 'learnerDashboard',
          showBackToResultButton: true
        }
        return this.$router.push({name: 'programGuideIntroduction', params: routerParams, query: {returnTo: 'learnerDashboard'}})
      }
		}
	}
</script>

<style scoped>
  .program-thumbnail {
    padding-top: 0px;
  }
  .pg-title {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 18px !important;
  }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerExplorePrograms.vue